import { CountingCirclesRecord, CountingCirclesResponse } from 'api/api.types';
import ProportionalMapWrapper from 'lib/Map/ProportionalMap/ProportionalMapWrapper';
import MapSwitch, { MuniTab } from 'lib/MapSwitch/MapSwitch';
import MunicipalityList from 'lib/MunicipalityList/MunicipalityList';
import React from 'react';
import { UseQueryResult } from 'react-query';

interface Props {
  selectedMuniTab: MuniTab;
  setSelectedMuniTab: (tab: MuniTab) => void;
  map: string;
  query: UseQueryResult<CountingCirclesResponse, unknown>;
  hoveredMapElement: CountingCirclesRecord;
  selectedMapElement: CountingCirclesRecord;
  isLoadingMap: boolean;
  render: (
    municipality: CountingCirclesRecord,
    prevDistrict?: CountingCirclesRecord,
  ) => JSX.Element;
  setSelectedMapElement: (selectedMapElement: CountingCirclesRecord) => void;
  hasThirdTablevel?: boolean; // only next to the third-level tabs do we have space for the switch.
  // In other cases, we show the switch next to the select/searchbar
}

const MunicipalityView = ({
  selectedMuniTab,
  setSelectedMuniTab,
  map,
  query,
  hoveredMapElement,
  selectedMapElement,
  isLoadingMap,
  render,
  setSelectedMapElement,
  hasThirdTablevel,
}: Props) => {
  return (
    <div className="municipalityview">
      {hasThirdTablevel && (
        <MapSwitch
          selectedTab={selectedMuniTab}
          setSelectedTab={setSelectedMuniTab}
          isAbsolute
        />
      )}
      {selectedMuniTab === 'map' ? (
        <ProportionalMapWrapper
          map={map}
          records={query.data?.data?.records}
          hoveredMapElement={hoveredMapElement}
          selectedMapElement={selectedMapElement}
          isLoadingMap={isLoadingMap}
          render={render}
          setSelectedMapElement={setSelectedMapElement}
          addMapSwitch={!hasThirdTablevel}
          selectedMuniTab={selectedMuniTab}
          setSelectedMuniTab={setSelectedMuniTab}
        />
      ) : (
        <MunicipalityList
          checksum={query.data?.meta?.data_checksum_sha256}
          municipalities={query.data?.data?.records}
          render={render}
          selectedMuni={selectedMapElement}
          setSelectedMuni={setSelectedMapElement}
          addMapSwitch={!hasThirdTablevel}
          selectedMuniTab={selectedMuniTab}
          setSelectedMuniTab={setSelectedMuniTab}
        />
      )}
    </div>
  );
};

export default MunicipalityView;
